import { LoadState } from "../../../constants/enums";

export interface ICustomerStatementState {
  list: ICustomerStatement[];
  loading: LoadState;
}

export interface ICustomerStatement  {
  amount: string;
  invoice_or_payment_date: string;
  invoice_or_payment_number: string;
  invoice_or_payment_id: number;
  transaction_type: string;
  type: "Invoice" | "Payment";
  policy_number: string;
  running_balance: number;
}

export const initialCustomerStatementState: ICustomerStatementState =
  {
    list: [],
    loading: LoadState.NotLoaded,
  };
